import { GroupListItem } from "@themuse/design-system/lib/components/GroupList/GroupList";

import {
    SearchCompany,
    SearchFilters,
    SearchLocation,
    SearchKeyword
} from "../interfaces/context/searchContextInterfaces";

/**
 * Counts the number of selected filters by checking if values are non-empty.
 */
const countFilterValues = (count: number, value: string | string[]): number => {
    if (Array.isArray(value)) {
        return count + value.filter(Boolean).length;
    }
    if (value) {
        return count + 1;
    }
    return count;
};

interface GetSelectedFilterCountProps {
    filters: SearchFilters;
    location: SearchLocation;
    company: SearchCompany;
    keyword: SearchKeyword;
}

/**
 * Calculates the total number of selected filters, including remote location adjustments.
 */
export const getSelectedFiltersCount = (props: GetSelectedFilterCountProps): number => {
    const {
        filters,
        location,
        company,
        keyword
    } = props;
    let filterCount: number = Object.values(filters).reduce(countFilterValues, 0);
    filterCount += keyword.userInputValue || keyword.userSelectedKeyword?.value ? 1 : 0;
    filterCount += company.userSelectedCompany?.value ? 1 : 0;
    filterCount += location.userSelectedLocation?.value ? 1 : 0;
    return filterCount;
};

export const getFacetValuesFromFacetItems = (filterParamValue: string, facetItems: GroupListItem[]) => {
    const splitValues = decodeURIComponent(filterParamValue).split(",");
    return splitValues.map((elem) => {
        const facetItem = facetItems.find((item) => item.value.toLowerCase() === elem.toLowerCase());
        return (facetItem) ? facetItem.value : null;
    }).filter((elem) => elem !== null);
};
